import { render } from "./Contacts.vue?vue&type=template&id=4c146d58&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=4c146d58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c146d58"

export default script